export function normalizeInternalName(value: string) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function resolveAutoInternalName(previousDisplayName: string, currentInternalName: string, nextDisplayName: string) {
  return normalizeInternalName(currentInternalName);
}
